var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2884",
    "data-name": "Group 2884",
    transform: "translate(-15238 3477)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_19213c82db4dc9de9b9816e580f5dd6b",
    "data-name": "19213c82db4dc9de9b9816e580f5dd6b",
    d: "M15.71,12.279a3.428,3.428,0,0,0-2.639,1.268L8.7,11.533A3.119,3.119,0,0,0,8.7,9.6l4.371-2.014a3.428,3.428,0,1,0-.788-2.16,3.573,3.573,0,0,0,.06.608L7.818,8.114a3.428,3.428,0,1,0,0,4.9L12.343,15.1a3.574,3.574,0,0,0-.06.608,3.428,3.428,0,1,0,3.428-3.428Zm0-8.57A1.714,1.714,0,1,1,14,5.423,1.714,1.714,0,0,1,15.71,3.709ZM5.427,12.279a1.714,1.714,0,1,1,1.714-1.714A1.714,1.714,0,0,1,5.427,12.279ZM15.71,17.421a1.714,1.714,0,1,1,1.714-1.714A1.714,1.714,0,0,1,15.71,17.421Z",
    transform: "translate(15237.434 -3477.551)",
    fill: "#16ebc3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1139",
    "data-name": "Rectangle 1139",
    width: 20,
    height: 20,
    transform: "translate(15238 -3477)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.4c50398af04ae8e6c30b5ca875eb46ec.svg";
export { ForwardRef as ReactComponent };